module.exports = {
    /* eslint-disable */
    githubSrc: 'https://raw.githubusercontent.com/kind-lab/b2ai-peds-protocol/51053b00a7212ef1d6798cb75b66d71171876ff9/peds-protocol-questionnaires/peds-protocol/peds-protocol',
    banner: 'B2AI data collection',
    startButton: 'Start',
    assetsPublicPath: '/b2ai-peds-protocol/questionnaires/',
    backendServer: null
  };